/** @format */
import { createMachine } from 'xstate';

// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export enum RequestPasswordResetMachineAction {
    SUBMIT = 'submit',
}

// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export enum RequestPasswordResetMachineState {
    FORM = 'form',
    CONFIRMATION_PENDING = 'confirmation-pending',
}

export const requestPasswordResetMachine = createMachine({
    predictableActionArguments: true,
    id: 'request-password-reset-machine',
    initial: RequestPasswordResetMachineState.FORM,
    states: {
        [RequestPasswordResetMachineState.FORM]: {
            on: {
                [RequestPasswordResetMachineAction.SUBMIT]:
                    RequestPasswordResetMachineState.CONFIRMATION_PENDING,
            },
        },
        [RequestPasswordResetMachineState.CONFIRMATION_PENDING]: {},
    },
});
